/* @flow */
import { fetchApi } from 'utils/ajax';
import type { FetchOptions, CallApi } from 'utils/ajax';
import { setMessage } from 'ducks/message';
import { getJSON } from 'redux-api-middleware';

export type State = {
  isFetching: bool,
}
export type Action = { type: string, payload: {data: any} }
export type Options = { program: string, project: string }

export let WORKFLOW_REQUEST = 'gdc/WORKFLOW_REQUEST';
export let WORKFLOW_SUCCESS = 'gdc/WORKFLOW_SUCCESS';
export let WORKFLOW_FAILURE = 'gdc/WORKFLOW_FAILURE';
export let WORKFLOW_RESET = 'gdc/WORKFLOW_RESET';

function workflow(opts: FetchOptions, dispatch: Function, successMessage: string, failureMessage: string): CallApi {
  return fetchApi({
    types: [WORKFLOW_REQUEST, {
      type: WORKFLOW_SUCCESS,
      payload: (action, state, res) => getJSON(res),
      // meta only used for side effect
      meta: () => dispatch && successMessage && dispatch(setMessage(successMessage))
    }, {
      type: WORKFLOW_FAILURE,
      // meta only used for side effect
      meta: () => dispatch && failureMessage && dispatch(setMessage(failureMessage))
    }],
    method: 'put',
    endpoint: opts.endpoint
  });
}

export function resetWorkflow() {
  return {
    type: WORKFLOW_RESET,
    payload: null
  };
}

export function open({ program, project }: Options): CallApi {
  return dispatch => {
    dispatch(workflow({
      endpoint: `${program}/${project}/open`
    }, dispatch));
  };
}

export function review({ program, project }: Options): CallApi {
  return dispatch => {
    dispatch(workflow({
      endpoint: `${program}/${project}/review`
    }, dispatch));
  };
}

export function submit({ program, project }: Options): CallApi {
  return dispatch => {
    dispatch(workflow({
      endpoint: `${program}/${project}/submit?async=true`
    }, dispatch,
      `${program}-${project} harmonization is requested`,
      `Error requesting harmonization for ${program}-${project}`
    ));
  };
}

export function release({ program, project }: Options): CallApi {
  return dispatch => {
    return dispatch(workflow({
      endpoint: `${program}/${project}/release`
    }, dispatch,
    `${program}-${project} release is requested`,
    `Error requesting release for ${program}-${project}`
  ));
  };
}

export default function reducer(state: State = {
  isFetching: false,
  transaction_id: null
}, action: Action): State {
  switch (action.type) {
  case WORKFLOW_REQUEST:
    return {
      ...state,
      isFetching: true
    };
  case WORKFLOW_SUCCESS:
    return {
      ...state,
      transaction_id: action.payload.transaction_id,
      isFetching: false,
    };
  case WORKFLOW_FAILURE:
    return {
      ...state,
      isFetching: false
    };
  case WORKFLOW_RESET:
    return {
      transaction_id: null,
      isFetching: false,
    };
  default:
    return state;
  }
}
